export const Book = (props) => {
  const { img, title, author, number } = props;
  return (
    <article className="book">
      <img src={img} alt={title} />
      <h4>{title}</h4>
      <h5>{author}</h5>
      <span className="number"># {number + 1}</span>
    </article>
  );
};
